import { render, staticRenderFns } from "./ModuleInstaller.vue?vue&type=template&id=29a1c12e&scoped=true"
import script from "./ModuleInstaller.vue?vue&type=script&lang=js"
export * from "./ModuleInstaller.vue?vue&type=script&lang=js"
import style0 from "./ModuleInstaller.vue?vue&type=style&index=0&id=29a1c12e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a1c12e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29a1c12e')) {
      api.createRecord('29a1c12e', component.options)
    } else {
      api.reload('29a1c12e', component.options)
    }
    module.hot.accept("./ModuleInstaller.vue?vue&type=template&id=29a1c12e&scoped=true", function () {
      api.rerender('29a1c12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/modulos/autoridad-registro/ModuleInstaller.vue"
export default component.exports